import { Component, ViewContainerRef, effect, inject, viewChild } from '@angular/core';

import { MessagesPanelComponent } from '../messages/messages-panel/messages-panel.component';
import { ActivityPanelComponent } from '../activity/activity-panel/activity-panel.component';
import { MarketingComponent } from '../shared/marketing/marketing.component';
import { PeerComparisonPanelComponent } from '../products/dashboard/peer-comparison-panel/peer-comparison-panel.component';
import { UserService } from '../shared/services/user.service';
import { ComponentRegistry } from '../products/components/component-lookup';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [MessagesPanelComponent, ActivityPanelComponent, MarketingComponent, PeerComparisonPanelComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  content = viewChild.required('content', { read: ViewContainerRef });

  readonly userProducts = inject(UserService).userProducts;

  constructor() {
    effect(() => {
      // const userProducts = this.userProducts();
      this.content().clear();
      // if (userProducts.some(p => p.hasDashboard == true)) {
        const component = ComponentRegistry.get("PeerComparisonPanel");
        if (component) {
          if (!this.content().createComponent(component)) {
            console.error(`Failed to create component: PeerComparisonPanel`);
          }
        }
      // }
    });
  }
}
